export default "__VITE_ASSET__B3DFRcjG__"